<template>
    <span v-if="invoice !== {}">
        <b-link
            v-if="useRouter && invoice.encoded_id"
            :to="{ name: 'invoice', params: { id: invoice.encoded_id } }"
        >
            {{ text || label }}
        </b-link>
        <a
            v-else-if="!useRouter && invoice.ci_url"
            :href="env.APPS + invoice.ci_url || '#'"
            :target="newTab ? '_blank' : '_self'"
        >
            {{ text || label }}
        </a>
        <a
            v-else-if="!useRouter && invoice.encoded_id"
            :href="
                env.APPS + 'billing/invoice/view/' + invoice.encoded_id || '#'
            "
            :target="newTab ? '_blank' : '_self'"
        >
            {{ text || label }}
        </a>
        <span v-else> {{ text || label }} </span>
        <input
            type="hidden"
            name="invoice_id"
            :value="invoice.id ? invoice.id : ''"
        />
    </span>
</template>

<script>
export default {
    name: "invoiceLink",
    props: {
        invoice: {
            type: Object,
            required: true,
            default: () => {}
        },
        /**
         * text: label shown. if not specified, invoice.label will be used
         */
        text: {
            type: String,
            default: null
        },
        /**
         * useRouter: true = use react router push, false = use native anchor href
         */
        useRouter: {
            type: Boolean,
            default: true
        },
        /**
         *  newTab: To create new tab. If not specifited, new tab will be created
         */
        newTab: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        label() {
            return "Invoice #" + this.invoice.index;
        }
    }
};
</script>
